module.exports = __webpack_public_path__ + "images/map-marker_d1e101b.png";